import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "position"]
  static values = { url: String }

  connect() {
    this.draggingId = null
  }

  dragStart(event) {
    const row = event.currentTarget
    this.draggingId = row.dataset.sizeCurveId
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.draggingId)
    row.classList.add("bg-slate-100")
  }

  dragEnd(event) {
    event.currentTarget.classList.remove("bg-slate-100")
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  drop(event) {
    event.preventDefault()
    const targetRow = event.currentTarget
    const targetId = targetRow.dataset.sizeCurveId
    const draggedId = this.draggingId || event.dataTransfer.getData("text/plain")
    if (!draggedId || draggedId === targetId) return

    const draggedRow = this.rowTargets.find((row) => row.dataset.sizeCurveId === draggedId)
    if (!draggedRow) return

    const rect = targetRow.getBoundingClientRect()
    const shouldInsertAfter = event.clientY > rect.top + rect.height / 2
    if (shouldInsertAfter) {
      targetRow.after(draggedRow)
    } else {
      targetRow.before(draggedRow)
    }

    this.persistOrder()
  }

  persistOrder() {
    if (!this.hasUrlValue) return

    const order = this.rowTargets.map((row) => row.dataset.sizeCurveId)
    this.rowTargets.forEach((row, index) => {
      const positionCell = row.querySelector("[data-size-curve-sort-target='position']")
      if (positionCell) {
        positionCell.textContent = `${index + 1}`
      }
    })
    const token = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ order })
    })
  }
}
